export function publisherTableFilterToClauses(filter, sspFilter) {
  let filters = [];

  for(let field in filter) {
    let value = filter[field];

    if (!!value && value.trim().match(/^[<=>]/)) {
      let [operation, operationValue] = value.trim().split(/\s+/);

      if (!operationValue) {
        operation = value.substring(0, 1);
        operationValue = value.substring(1);
      }

      console.log("operationValue", operationValue);

      let intOperationValue = parseInt(operationValue);

      console.log("intOperationValue", intOperationValue);

      if (Number.isInteger(intOperationValue)) {
        switch (operation) {
          case '<':
            filters.push({dimension: field, comparison_keyword: 'LT', value: intOperationValue});
            break;
          case '>':
            filters.push({dimension: field, comparison_keyword: 'GT', value: intOperationValue});
            break;
          case '=':
            filters.push({dimension: field, comparison_keyword: 'EQ', value: intOperationValue});
            break;
        }
      }
    } else if (!!value) {
        switch (field) {
          case 'bundle':
            filters.push({dimension: field, comparison_keyword: 'LIKE', value: value});
            break;
          case 'publisher':
            filters.push({dimension: 'publisher_id', comparison_keyword: 'LIKE', value: value});
            break;
          default:
            filters.push({dimension: field, comparison_keyword: 'EQ', value: value});
            break;
        }
    }
  }

  if (sspFilter !== undefined) {
    filters.push({dimension: 'ssp_id', comparison_keyword: 'IN', value: sspFilter});
  }

  return {filters: filters};
}



/** WEBPACK FOOTER **
 ** ./src/components/campaigns/publisherTableFilterToConditions.js
 **/